<ng-container *transloco="let t">
  <div class="modal-header d-flex align-items-center justify-content-start">
    <button type="button" class="btn-back" aria-label="Close" (click)="onClose()">
      <i class="bi bi-arrow-left cursor-pointer"></i>
    </button>
    <p class="ps-2">{{ t('app.user.my.tracy.back') | uppercase }}</p>
  </div>
  <div class="create-list-form px-3 py-2 my-2 justify-content-between align-items-center">
    <h4 class="pb-2">Create custom list</h4>
    <form #signUp="ngForm" [formGroup]="inputForm">
      <div class="row">
        <div class="col-lg-6 col-12">
          <app-input formControlName="listName" label="app.user.my.tracy.create.list.name"/>
        </div>
        <div class="col-lg-6 col-12 pt-2 pt-lg-0">
          <app-input formControlName="description" label="app.user.my.tracy.create.list.description"/>
        </div>
      </div>
    </form>

  </div>
</ng-container>
